import React from "react"
import { Input } from ".";
import { useForm, useWatch, FormProvider, useFormContext } from "react-hook-form"
import { Button } from "../Button";


const InputCompare = (props) => {

    const { setValue } = useFormContext();

    const handleSelectValue = (fieldName, fieldValue) => {
        setValue(fieldName, fieldValue);
    }



    return (

        <tr>
            <td width={"33%"}>
                <Button
                    fullWidth
                    onClick={() => handleSelectValue(props.name, props.item[props.name])}
                    variant={"plain"} >{props.item[props.name]}</Button>
            </td>
            {(props.item.similars ?? []).map((item, index) => (
                <td key={index} width={"33%"}>
                    <Button
                    fullWidth
                    onClick={() => handleSelectValue(props.name, item.data[props.name])}
                    variant={"plain"} >{item.data[props.name]}</Button>
                </td>
            ))}
            <td width={"33%"}> <Input {...props} /></td>
        </tr>
    );

};

export default InputCompare
